import { useCallback, useEffect } from 'react';

export enum MessageType {
  AUTH_SUCCESS = 'authSuccess',
  AUTH_FAILURE = 'authFailure',
  PAYMENT_SUCCESS = 'paymentSuccess',
}

export const useSendPostMessage = () => {
  const sendPostMessage = useCallback((messageType: MessageType, cb?: () => void) => {
    const message = { type: messageType };
    const origin = window.location.origin;

    // @ts-expect-error
    if (window.ReactNativeWebView) {
      // Mobile App case
      // @ts-expect-error
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    } else if (window.opener) {
      // `'*'` allows cross-origin openers; receivers MUST validate
      // `event.origin` against this page's host before trusting the message.
      window.opener.postMessage(message, '*');
    } else if (window.parent.location.pathname !== window.location.pathname) {
      window.parent.postMessage(message, origin);
    } else {
      console.log('no opener');
    }

    cb?.();
  }, []);

  return { sendPostMessage };
};

export const usePostMessageListener = (messageType: MessageType, handler: () => void) => {
  const handleMessage = useCallback(
    async (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      if (event.data.type === messageType) {
        handler();
      }
    },
    [handler, messageType],
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);
};
